import { useMemo } from 'react';

import dateFormat from 'dateformat';

import { renderInfinityChannels } from '@components/Product/Pricelists/functions';
import { BootstrapTable } from '@components/Table/Table';

export const SharedCostTariffTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'Area',
        accessor: 'area',
      },
      {
        Header: 'Type',
        accessor: 'did_type',
      },
      {
        Header: 'Type of caller',
        accessor: 'nature',
      },
      {
        Header: 'Inbound Plan',
        accessor: 'inbound_plan',
      },
      {
        Header: 'NRC',
        accessor: 'nrc_number',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_number',
      },
      {
        Header: '# dflt',
        accessor: 'default_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: '# max',
        accessor: 'max_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: 'NRC',
        accessor: 'nrc_channels',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_channels',
      },
      {
        Header: 'Call setup',
        accessor: 'setup_cost',
      },
      {
        Header: 'Price Per Minute',
        accessor: 'price_per_minute',
      },
      {
        Header: 'Billing Method',
        accessor: 'billing_method',
      },
      {
        Header: 'Date Active',
        accessor: 'date_active',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
        setMinWidth: '90px',
      },
      {
        Header: 'Change',
        accessor: 'description',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        striped: true,
        className: 'normalFontSize',
      })}
      isLoading={isLoading}
    />
  );
};
